import { get, post } from 'src/tools/server';
export const getSetting = () => {
  return get<any>('/portal/setting/3rdParty', {});
};

export const saveSetting = (data) => {
  return post<any>('/portal/setting/3rdParty', data, {});
};
